'use client';

import Image from 'next/image';
import Link from 'next/link';

import Button from '@/components/button/Button';
import { ButtonStyle } from '@/components/button/ButtonStyle.enum';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

const ErrorImage = loadAsset('images/illustrations/spotlight/im-404.png');

// This component renders outside next-intl and domain-theming providers (used by both the
// segment-level error.tsx and the root global-error.tsx), so copy is bilingual (DE primary, EN
// secondary) and styling falls back to the plain darkBlue/cyan theme instead of domain colors.
export default function ErrorPage({ onReset }: { onReset: () => void }) {
    return (
        <main className="w-full min-h-dvh flex items-center justify-center bg-darkBlue text-white">
            <div className="container mx-auto flex flex-col lg:flex-row gap-[44px] lg:gap-[88px] py-[48px] items-center">
                <div className="relative w-full h-auto flex flex-col justify-center space-y-32 order-1 lg:order-0 flex-1 grow">
                    <div className="space-y-16">
                        <div className="space-y-12">
                            <h1 className="text-overline-16 text-cyan">Fehler</h1>
                            <h1 className="text-headline-24 lg:text-headline-32">Ups, da ist etwas schiefgelaufen.</h1>
                        </div>
                        <div className="space-y-4">
                            <p className="text-body-16">
                                Wir wurden automatisch informiert und kümmern uns bereits darum. Bitte versuchen Sie es
                                erneut oder kehren Sie zur Startseite zurück.
                            </p>
                            <p className="text-body-14 text-white/50">
                                Something went wrong. We&apos;ve been notified automatically — please try again or head
                                back to the homepage.
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-row flex-wrap gap-16">
                        <Button
                            className="h-36"
                            onClick={onReset}>
                            Erneut versuchen
                        </Button>
                        <Link href="/">
                            <Button
                                className="h-36"
                                style={ButtonStyle.outlined}>
                                Zur Startseite
                            </Button>
                        </Link>
                    </div>
                </div>
                <div className="relative max-h-[280px] lg:max-h-[440px] order-0 lg:order-1 flex-1 grow">
                    <Image
                        className="relative w-full h-auto max-h-[280px] lg:max-h-[440px] object-contain"
                        src={ErrorImage}
                        alt="Error"
                        width={800}
                        height={800}
                    />
                </div>
            </div>
        </main>
    );
}
